import RelativePositionComponent from "Component/Render/RelativePosition";
import { GameObjectEvent } from "GameObject/GameObject";
import { QuitPlinkoMinigamePopupLayout } from "Layouts/Plinko/QuitPlinkoMinigamePopup";
import { GameActions } from "State/Game/GameActions";
import { PopupID } from "State/UI/PopupID";
import { UIActions } from "State/UI/UIActions";
import BaseUISystem from "System/UI/BaseUISystem";
import { getLayout, GLayout } from "Utility/layout/LayoutHelper";
import { applyDefaultButtonAnimation } from "../UIHelper";
import BaseMenu from "./BaseMenu";

export class QuitPlinkoMinigamePopup extends BaseMenu {
    private layout: GLayout<QuitPlinkoMinigamePopupLayout>;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.PLINKO_MINI_GAME_QUIT, uiSystem, false);
    }

    public onShow(params: any) {
        super.onShow(params);

        this.layout = getLayout(QuitPlinkoMinigamePopupLayout);
        this.layout.root.addComponent(RelativePositionComponent, { x: 0.5, y: 0.5 });
        this.element.addChild(this.layout.root);

        const { closeButton, stayButton, leaveButton } = this.layout;

        [
            leaveButton,
            closeButton,
            stayButton
        ].forEach(button => {
            applyDefaultButtonAnimation(button);
        });

        [
            closeButton,
            stayButton
        ].forEach(ob => {
            ob.once(GameObjectEvent.SELECTED, () => { UIActions.hidePopup(this.name) });
        });

        leaveButton.once(GameObjectEvent.SELECTED, () => {
            GameActions.loadWorld();
        });
    }
}
